import React, { Fragment, useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";

import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import AdminNewsletterService from '../../api/services/AdminNewsletterService';
import swal from "sweetalert";

const NewslettersUpdate = () => {

    const [Error, setError] = useState('');
    const [Newsletter, SetNewsletter] = useState([]);
    const params = useParams();
    const navigate = useNavigate()
    const [isLoading, setisloading] = useState(true);
    const GetNewsletter = async (id) => {
        try {
            let responseData = await AdminNewsletterService.show(id).json()
            SetNewsletter(responseData.data);
            setisloading(false)


        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            GetNewsletter(params.id);
        }
        else {
            navigate('/');
        }

    }, [])

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            var userData = {
                "first_name": event.target.first_name.value,
                "email": event.target.email.value,
               
            }
            const data = await AdminNewsletterService.update(params.id, userData).json();

            if (data.status === true) {

                swal("Newsletter Update Succesfully").then((willDelete) => {
                    if (willDelete) {
                        navigate('/admin/newsletters')
                    }
                })

            }


        }
        catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    return (
        <Fragment>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Newsletter</h4>
                            </div>
                            <div className="card-body">
                                <div className="form-validation">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-xl-6 mb-3">
                                                <label htmlFor="exampleFormControlInput1" className="form-label">First Name<span className="text-danger">*</span></label>
                                                <input type="text" name="first_name" defaultValue={Newsletter.first_name} className="form-control" id="exampleFormControlInput1" placeholder="" />
                                            </div>
                                            <div className="col-xl-6 mb-3">
                                                <label htmlFor="exampleFormControlInput2" className="form-label"> Email <span className="text-danger">*</span></label>
                                                <input type="text" name='email' defaultValue={Newsletter.email} className="form-control" id="exampleFormControlInput2" placeholder="" />
                                            </div>

                                         

                                            <p className='text-danger fs-12'>{Error}</p>

                                        </div>
                                        <div>
                                            <button type="submit" className="btn btn-primary me-1">Submit</button>
                                            {/* <Link to={'/admin/newsletters'} type="reset" className="btn btn-danger light ms-1">Cancel</Link> */}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </Fragment>
        
    );
};

export default NewslettersUpdate;
